import React, { Component } from "react";
import { BrowserRouter as Router, Route} from "react-router-dom";
import "./App.css";
import "leaflet/dist/leaflet.css";
import MapComponents from "./components/MapComponents";

class App extends Component {
  render() {
    return(
      <Router>
        <Route render={ (props) =>
          <MapComponents location={props.location} />
        }/>
        </Router>
    );
  }
}

export default App;
